import { v2 } from "../../utils/apiClients";
import { unwrapPage } from "./apiResponse";

export const userService = {
  updateIndividualPersonalInfo: async (data) => {
    const response = await v2.put(
      "/user/updateIndividualPersonalInformation",
      data,
    );
    return response.data;
  },
  getUserProfile: async () => {
    const response = await v2.get("/user/profile");
    return response.data;
  },
  updateIndividualAddressInfo: async (data) => {
    const response = await v2.put(
      "/user/updateIndividualAddressInformation",
      data,
    );
    return response.data;
  },
  updateIndividualIdentityInfo: async (data) => {
    const response = await v2.put(
      "/user/updateIndividualIdentityVerificationInformation",
      data,
    );
    return response.data;
  },
  updateIndividualPin: async (data) => {
    const response = await v2.put("/user/updateIndividualPin", data);
    return response.data;
  },
  updateOrganizationInfo: async (data) => {
    const response = await v2.put("/user/updateOrganizationInformation", data);
    return response.data;
  },
  completeOnboarding: async () => {
    const response = await v2.put("/user/completeOnboarding");
    return response.data;
  },
  updateMoreOrganizationInfo: async (data) => {
    const response = await v2.put(
      "/user/updateMoreOrganizationInformation",
      data,
    );
    return response.data;
  },
  updateOrganizationAddressInfo: async (data) => {
    const response = await v2.put(
      "/user/updateOrganizationAddressInformation",
      data,
    );
    return response.data;
  },
  createOrganizationStakeholder: async (data, idempotencyKey) => {
    const response = await v2.post(
      "/organizationStakeholder/createOrganizationStakeholder",
      data,
      {
        headers: {
          "Idempotency-Key": idempotencyKey,
        },
      },
    );
    return response.data;
  },
  createBulkOrganizationStakeholders: async (data, idempotencyKey) => {
    const response = await v2.post(
      "/organizationStakeholder/bulkCreateOrganizationStakeholders",
      data,
      {
        headers: {
          "Idempotency-Key": idempotencyKey,
        },
      },
    );
    return response.data;
  },
  bulkUpdateOrganizationStakeholders: async (data) => {
    const response = await v2.put(
      "/organizationStakeholder/bulkUpdateOrganizationStakeholders",
      data,
    );
    return response.data;
  },
  updateOrganizationStakeholderAddress: async (data) => {
    const response = await v2.put(
      "/organizationStakeholder/updateOrganizationStakeholderAddress",
      data,
    );
    return response.data;
  },
  getOrganizationStakeholders: async (id) => {
    const response = await v2.get(
      `/organizationStakeholder/getOrganizationStakeholders/${id}`,
    );
    return response.data;
  },
  updateOrganizationDocument: async (data) => {
    const response = await v2.put("/user/updateOrganizationDocument", data);
    return response.data;
  },
  updateOrganizationStakeholder: async (data) => {
    const response = await v2.put(
      "/organizationStakeholder/updateOrganizationStakeholder",
      data,
    );
    return response.data;
  },
  deleteOrganizationStakeholder: async (id) => {
    const response = await v2.delete(
      `/organizationStakeholder/deleteOrganizationStakeholder/${id}`,
    );
    return response.data;
  },
  updateOrganizationPin: async (data) => {
    const response = await v2.put("/user/updateOrganizationPin", data);
    return response.data;
  },
  updateOrganizationProfileImage: async (data) => {
    const response = await v2.put("/user/updateOrganizationProfileImage", data);
    return response.data;
  },
  updateIndividualProfileImage: async (data) => {
    const response = await v2.put("/user/updateIndividualProfileImage", data);
    return response.data;
  },
  getReferrals: async ({ PageNumber, pageSize } = {}) => {
    const response = await v2.get("/Rewards/referrals", {
      params: { page: PageNumber, pageSize },
    });
    return unwrapPage(response);
  },
  getReferralSummary: async () => {
    const response = await v2.get("/Rewards/referrals", {
      params: { page: 1, pageSize: 1 },
    });
    const raw = response.data;
    return raw?.data?.summary ?? raw?.summary ?? {};
  },
  convertReward: async ({ amount, walletPublicId = null, notes = null }) => {
    const response = await v2.post("/Rewards/convert", {
      amount,
      walletPublicId,
      notes,
    });
    return response.data;
  },
  getRewardSummary: async () => {
    const response = await v2.get("/Rewards/balance");
    const raw = response.data?.data || {};
    return {
      data: {
        availableBalance: raw.availableBalance ?? 0,
        lifetimeAccrued: raw.lifetimeAccrued ?? 0,
        lifetimeRedeemed: raw.lifetimeRedeemed ?? 0,
        currency: raw.currency,
        status: raw.status,
      },
    };
  },
  getRewards: async ({ page, pageSize } = {}) => {
    const response = await v2.get("/Rewards/history", {
      params: { page, pageSize },
    });
    return unwrapPage(response);
  },
};
